<div class="sidebar h-[10vh]" [class.expanded]="(isExpanded$ | async) || (isPinned$ | async)"
    (mouseenter)="expandSidebar()" (mouseleave)="collapseSidebar()" >


    <div class="pin-icon" style="text-align: right;
    padding: 7px;
    margin-left: 2px;
    padding-top: 11px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: -9px;
    ">
        <div>
            <p-iconfield *ngIf="isExpanded$ | async" class="search-bar"
                [ngClass]="{'expanded': isExpanded$ | async, 'collapsed': !(isExpanded$ | async)}">
                <input style="max-width: 161px;
            border-radius: 30px;height: 26px;"
                [(ngModel)]="searchValue" (ngModelChange)="search()"
             type="text" pInputText placeholder="Search" />
                <p-inputicon styleClass="pi pi-search" />
            </p-iconfield>
        </div>
        <i *ngIf="isExpanded$ | async" class="search-bar"
            [ngClass]="{'expanded': isExpanded$ | async, 'collapsed': !(isExpanded$ | async)}" (click)="togglePin()"
            style="margin-right: 0px; padding: 6px 16px;" class="mr-0 cursor-pointer " class="pi"
            [ngClass]="(isPinned$ | async) ? 'pi-lock' : 'pi-lock-open'"></i>

        <i *ngIf="!(isExpanded$ | async)" (click)="togglePin()"
            style="margin-right: 0px; padding: 6px 16px; margin-right: 9px;"
            class=" cursor-pointer pi pi-search -ml-3 pl-0 mr-[9px]"></i>
    </div>

    <p-divider />
    <ul>
        <li *ngFor="let item of sidebarItems" [routerLink]="item.route" [class.has-submenu]="item.subMenu"
            style="padding: 0;">
            <ng-container *ngIf="item.show">
                <div class="flex items-center justify-between w-full nav-list-item" routerLinkActive="active"
                    (click)="toggleSubMenu(item)">
                    <div class="flex items-center">
                        <i [class]="item.icon"></i>
                        <span>{{ item.title }}</span>
                    </div>
                    <i *ngIf="item.subMenu" class="pi pi-angle-down submenu-icon" [class.open]="item.isOpen"></i>

                </div>

                <!-- Sub-menu items -->
                <ul *ngIf="item.subMenu && item.isOpen" class="submenu">
                    <li class="nav-sub-menu" *ngFor="let subItem of item.subMenu" [routerLink]="subItem.route"
                        routerLinkActive="active" (click)="item.isOpen = false" 
                        [style.display]="subItem.show ? 'block' : 'none'"
                        >
                        <div class="flex items-center flex-row" *ngIf="subItem.show">
                            <div>
                                <i [class]="subItem.icon"></i>
                            </div>
                            <div>
                                <span>{{ subItem.title }}</span>
                            </div>
                        </div>

                    </li>
                </ul>
            </ng-container>
        </li>

        <li *ngIf="sidebarItems.length === 0">
            <div class="flex items-center justify-center w-full nav-list-item">
                <span>No items to display</span>
            </div>
        </li>
    </ul>
</div>